import VueI18n from 'vue-i18n'
import Vue from 'vue'

import nl from './nl.json'
import en from './en.json'
import fr from './fr.json'

Vue.use(VueI18n)

const messages = {
  nl,
  en,
  fr
}
export default new VueI18n({
  locale: 'nl',
  messages,
  fallbackLocale: 'nl'
})
